export { default as Icon } from './Icon';
export * from './useIconStyleProps';
